import { render, staticRenderFns } from "./VMainColumnRecordVisualization.vue?vue&type=template&id=1f1ed14d"
import script from "./VMainColumnRecordVisualization.vue?vue&type=script&lang=js"
export * from "./VMainColumnRecordVisualization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports